export const DEFAULT_BAR_SIZE = 30;
export const DEFAULT_MARGIN = 10;
export const INITIAL_AXIS_WIDTH = 100;
